import { useState } from 'react'
interface ImageCropperHook {
   image: string | null
   error: string | null
}

// useImageCropper hook
const useValidateImage = (initialFile: File | null, maxSize: number): ImageCropperHook => {
   const [image, setImage] = useState<string | null>(null)
   const [error, setError] = useState<string | null>(null)

   // Quick exit if initialFile is null
   if (!initialFile) {
      return {
         image: null,
         error: null,
      }
   }

   const validateImageFileSize = (file: File): boolean => file.size <= maxSize

   const validateImageFileType = (file: File): boolean => {
      const fileType = file.type
      // create array of all image types
      const imageTypes = [
         'image/jpeg',
         'image/jpg',
         'image/png',
         'image/gif',
         'image/svg+xml',
         'image/webp',
         'image/bmp',
         'image/tiff',
      ]
      // check if file type is in array of image types
      return imageTypes.includes(fileType)
   }

   const reader = new FileReader()
   reader.onload = (e) => {
      if (e.target?.result) {
         const isImageTypeValid = validateImageFileType(initialFile)
         const isImageSizeValid = validateImageFileSize(initialFile)

         if (isImageTypeValid && isImageSizeValid) {
            setImage(reader?.result as string)
            setError(null)
         } else if (!isImageTypeValid) {
            setError('File type is not correct')
         } else if (!isImageSizeValid) {
            setError(`File size exceeds ${maxSize / 1024 / 1024} MB`)
         }
      } else {
         return {
            image: null,
            error: "File doesn't exist",
         }
      }
   }
   reader.readAsDataURL(initialFile)

   return {
      image,
      error,
   }
}

export default useValidateImage
